import resellersModule from "../resellersModule.js";

function assetResaleMigrationPaneController(resellersConstants, resaleService) {
    "ngInject";
    var ctrl = this;

    ctrl.loadResaleData = function () {
        if (ctrl.loadingResaleData) {
            return;
        }

        ctrl.loadingResaleData = true;
        ctrl.resaleDataLoadFailure = false;

        resaleService.getAssetResaleData(ctrl.assetId).then(function (resaleData) {
            ctrl.resaleData = resaleData;
            ctrl.loadingResaleData = false;
        }).catch(function () {
            ctrl.resaleDataLoadFailure = true;
            ctrl.loadingResaleData = false;
        });
    };

    const init = function () {
        ctrl.loadResaleData();
    };

    ctrl.$onInit = init;
}

resellersModule.controller("assetResaleMigrationPaneController", assetResaleMigrationPaneController);
export default assetResaleMigrationPaneController;
